export default __webpack_public_path__ + "static/media/studio-3.a513dfb5.jpg";